import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import Logo from "../../../svg/logo.svg";
import IcEnvelope from "../../../svg/ic-envelope1.svg";
import IcMobile from "../../../svg/ic-mobile1.svg";
import Image from "next/future/image";
import Arrow from "../../../svg/arrow.svg";
import nookies from "nookies";

const MobileSideBar = ({
  isMobileSideBarActive,
  handleMobileSideBarActivation,
  data,
  servicesData,
}) => {
  const { locale, push, pathname, asPath } = useRouter();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => (pathname === path ? "active" : "");

  const [dir, setDir] = useState("rtl");
  useEffect(() => {
    setDir(locale === "ar" ? "rtl" : "ltr");
  }, [locale]);

  const overLayActive = {
    display: `${isMobileSideBarActive ? "block" : "none"}`,
  };

  const changeLanguage = (event, language) => {
    event.preventDefault();
    nookies.set(null, "locale", language, { path: "/" });
    push(pathname, asPath, { locale: language });
  };

  return (
    <>
      <div
        className="overlay"
        style={overLayActive}
        onClick={handleMobileSideBarActivation}
      ></div>

      <div
        className={`mobileSideBar ${isMobileSideBarActive ? "active" : ""}`}
        dir={dir}
      >
        <div className="head">
          {data?.AppSetting?.appLogo && (
            <Link href="/">
              <a>
                <div className="logo">
                  <Image
                    src={`${process.env.NEXT_PUBLIC_API_URL}/${data?.AppSetting?.appLogo}`}
                    alt="logo"
                    width={1920}
                    height={1080}
                    priority={true}
                  />
                </div>
              </a>
            </Link>
          )}

          <svg
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            className="xmark"
            onClick={handleMobileSideBarActivation}
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier"></g>
            <g id="SVGRepo_iconCarrier">
              <rect width="16" height="16" id="icon-bound" fill="none"></rect>
              <polygon points="14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414 13.293,14.707 14.707,13.293 9.414,8 "></polygon>
            </g>
          </svg>
        </div>

        <div className="links">
          <Link href="/">
            <a className={`${isActive("/")} custom-link`}>
              <FormattedMessage id="home" />
            </a>
          </Link>

          <Link href="/aboutus">
            <a className={`${isActive("/aboutus")} custom-link`}>
              <FormattedMessage id="about" />
            </a>
          </Link>

          <button
            className={`mega-menu-button ${isMenuOpen ? "open" : ""}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <FormattedMessage id="services" />
            <Arrow />
          </button>
          <div className={`mega-menu ${isMenuOpen ? "active" : ""}`}>
            <Row>
              {servicesData?.slice(0, 4).map((item, index) => (
                <Col xs={12} key={index} className="mb-2">
                  <div className="mega-menu-item">
                    <Link href={`/services/${item?.slug}`}>
                      <a
                        className="mega-menu-link"
                        onClick={handleMobileSideBarActivation}
                      >
                        <div className="img">
                          {item?.image && (
                            <Image
                              src={`${process.env.NEXT_PUBLIC_API_URL}/${item.image}`}
                              alt={item?.title?.[locale] || "service"}
                              width={100}
                              height={100}
                            />
                          )}
                        </div>
                        {item?.title?.[locale] && (
                          <span className="title">
                            {item.title[locale].length > 24
                              ? `${item.title[locale].slice(0, 24)}...`
                              : item.title[locale]}
                          </span>
                        )}
                      </a>
                    </Link>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <Link href="/ourworks">
            <a className={`${isActive("/ourworks")} custom-link`}>
              <FormattedMessage id="our-works" />
            </a>
          </Link>

          <Link href="/blogs">
            <a className={`${isActive("/blogs")} custom-link`}>
              <FormattedMessage id="blogs" />
            </a>
          </Link>

          {/* <Link href="/contactus">
            <a className={`${isActive("/contactus")} custom-link`}>
              <FormattedMessage id="contact-us" />
            </a>
          </Link> */}

          <Link href="/contactus">
            <a className="contactus"  rel="noopener noreferrer">
              <FormattedMessage id="request-quote" />
            </a>
          </Link>

          <button
            onClick={(e) => changeLanguage(e, locale === "ar" ? "en" : "ar")}
            className="language"
          >
            {locale === "ar" ? "en" : "العربية"}
          </button>
        </div>

        <div className="info">
          <Link href={`mailto:${data?.socials?.email}`} target="_blank">
            <a>
              <IcEnvelope
                className="image"
                alt="email-image"
                width={18}
                height={18}
              />
              {data?.socials?.email}
            </a>
          </Link>

          <Link href={`tel:${data?.socials?.phone}`}>
            <a className="phone">
              <IcMobile className="image" alt="phone-image" />
              <span>{data?.socials?.phone}</span>
            </a>
          </Link>
        </div>
      </div>
    </>
  );
};

export default MobileSideBar;
